import React, { Component, memo } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

// components
import Landing from './components/Landing/Landing';
import DrawBoard from './components/DrawBoard/DrawBoard';
import Gallery from './components/Gallery/Gallery';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import TeacherDashboard from './components/TeacherDashboard/TeacherDashboard';
import Authentication from './components/Authentication/Authentication';
import TeacherOnBoardSuccess from './components/TeacherOnBoardSuccess/TeacherOnBoardSuccess';
import NotFound from './components/NotFound/NotFound';
import Download from './components/Download/Download';
import FuntionalComponent from './components/FunctionalComponent/FuntionalComponent';

import ReactGA from 'react-ga4';
import { trackPageView } from './utils/Analytics';
import config from './config/config';

// Wrapper to inject `location` into class component
function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    return <Component {...props} location={location} />;
  }
  return memo(ComponentWithRouterProp);
}

class App extends Component {
  
  componentDidMount() {
    ReactGA.initialize(config.GOOGLE_ANALYTICS_ID, { gaOptions: { send_page_view: false } });
    this.sendPageView(this.props.location.pathname);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) { 
      this.sendPageView(this.props.location.pathname);
    }
  }

  sendPageView = (page) => {
    trackPageView(page);
  }

  render() {
    return (
        <Routes>
          <Route path='/' element={<Landing/>} />
          <Route path='/auth/:role/:componentName' element={<Authentication/>} />
          <Route path='/auth/:role/:componentName' element={<Authentication/>} />
          <Route path='/:componentName/:role/:encodedString' element={<Authentication/>} />

          <Route path='/gallery' element={<FuntionalComponent><Gallery/></FuntionalComponent>} />
          <Route path='/teacher/dashboard' element={<FuntionalComponent><TeacherDashboard/></FuntionalComponent>} />
          <Route path='/admin/dashboard' element={<FuntionalComponent><AdminDashboard/></FuntionalComponent>} />

          <Route path='/teacheronboardsuccess' element={<FuntionalComponent><TeacherOnBoardSuccess/></FuntionalComponent>} />
          <Route path='/drawboard' element={<FuntionalComponent><DrawBoard/></FuntionalComponent>} />
          <Route path='/teacherrefer/:id' element={<FuntionalComponent><DrawBoard/></FuntionalComponent>} />

          <Route path='/admin/download' element={<FuntionalComponent><Download/></FuntionalComponent>} />
          <Route element={<NotFound/>} />
        </Routes>
    )
  }
}

// Export App wrapped with BrowserRouter and location
export default function AppWithTracking() {
  const AppWithRouter = withRouter(App);

  return (
    <BrowserRouter>
      <AppWithRouter />
    </BrowserRouter>
  );
}